import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ItemService } from './../services/item.service';
import { Spot } from '../models/Item';
import { Chart } from 'chart.js';
import { AuthService } from '../core/auth.service';
import { User } from '../core/user';
import { Observable } from 'rxjs/Observable';
import { take } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';



@Component({
  selector: 'app-advertisers',
  templateUrl: './advertisers.component.html',
  styleUrls: ['./advertisers.component.css']
})
export class AdvertisersComponent implements OnInit {


  constructor(public itemService: ItemService, private afs: AngularFirestore, public router: Router, public route: ActivatedRoute, private authService: AuthService) { }

 

  hideNav = false;
  chart = [];
  // public data: any[];
  // dateSelected: any;
  public daterange: any = {};
  public advertiser: any;
  public options: any = {
    locale: { format: 'MM/DD/YYYY' },
    
    alwaysShowCalendars: false,
    startDate: this.itemService.sd,
    endDate: this.itemService.ed,
    minDate: '01/01/2017',
    opens: 'left',
    showWeekNumbers: true,
    ranges: {
      // 'Yesterday': [
      //     '2018-02-26T07:00:33.456Z',
      //     '2018-02-26T07:00:33.456Z'
      // ],
      'Last 7 Days': [
        '01/01/2017',
        '31/03/2018',
      ],
      'Last 30 Days': [
        '03/02/2018',
        '03/31/2018'
      ],
      'This Month': [
        '03/01/2018',
        '03/31/2018'
      ],
      'Last Month': [
        '02/01/2018',
        '02/28/2018'
      ]
    },
  };

  

  public selectedDate(value: any, datepicker?: any) {
    this.itemService.showSpinner = true;
    
    
    datepicker.start = value.start;
    datepicker.end = value.end;

    // or manupulat your own internal property
    this.daterange.start = value.start;
    this.daterange.end = value.end;
    this.daterange.label = value.label;

    let start;
    let end;
    start = new Date(this.daterange.start);
    end = new Date(this.daterange.end);

    // start Date Function
    const sd_date = ('0' + start.getDate()).slice(-2);
    const sd_Month = ('0' + (start.getMonth() + 1)).slice(-2);
    const sd_year = start.getFullYear();

    const startDate = ((sd_Month) + '-' + sd_date + '-' + sd_year);
    this.itemService.startDate = startDate;
    // console.log(this.itemService.startDate);

    // end Date Function
    const ed_date = ('0' + end.getDate()).slice(-2);
    const ed_Month = ('0' + (end.getMonth() + 1)).slice(-2);
    const ed_year = end.getFullYear();

    const endDate = ((ed_Month) + '-' + ed_date + '-' + ed_year);
    this.itemService.endDate = endDate;
    // console.log(this.itemService.endDate);

    // dateChanged Function

    this.itemService.startDateTemp = new Date(startDate)
    this.itemService.endDateTemp = new Date(endDate)
    this.itemService.days =  Math.round(Math.abs((this.itemService.startDateTemp.getTime() - this.itemService.endDateTemp.getTime())/(24*60*60*1000))) +1;


    let advertiserSelected = this.itemService.selected_adv ? this.itemService.selected_adv : 'Not Selected';
    let parameters:any = { 
      section_name: 'Advertisers',
      page_name: 'Dashboard',
      advertiser:advertiserSelected,
      startDate: this.itemService.startDate,
      days: this.itemService.days,
      endDate: this.itemService.endDate,
    }
    this.itemService.logEvent('onDateChange', parameters);

    this.itemService.dateChangeDetector();
  }


  onChange(value) {

    this.itemService.startDateTemp = new Date(this.itemService.sd)
    this.itemService.endDateTemp = new Date(this.itemService.ed)
    this.itemService.days =  Math.round(Math.abs((this.itemService.startDateTemp.getTime() - this.itemService.endDateTemp.getTime())/(24*60*60*1000))) +1;


    let parameters:any = { 
      section_name: 'Advertisers',
      page_name: 'Dashboard',
      advertiser:value,
      startDate: this.itemService.startDateTemp,
      days: this.itemService.days,
      endDate: this.itemService.endDateTemp,
    }
    this.itemService.logEvent('onAdvertiserChange', parameters);

    this.itemService.selected_adv_brand =  null;
    this.itemService.selected_adv = value;
    this.itemService.advertisers();
  }

  ngOnInit() {

    let parameters:any = { section_name: 'Advertisers', page_name: 'Dashboard'}
      this.itemService.logEvent('onPageView', parameters);

    if(this.itemService.remeberAdv) {
      this.itemService.selected_adv = this.itemService.remeberAdv;
    } else {
      this.itemService.selected_adv = null;
    }
    // this.itemService.selected_adv = null;
    this.hideNav = false;
    this.itemService.defaultDate();

    this.itemService.showSpinner = true;
    this.itemService.positions_ByCompanyChart= null
    this.itemService.selected_adv_brand = null;
    this.itemService.selected_adv_channel = null;
    this.itemService.selected_cat = null;    
    
    this.itemService.url =this.router.url;    
    // this.itemService.dateChangeDetector();
    if(this.itemService.dataAvailable){
      // console.log('Advertisers Block')
      this.itemService.advertisers();
      this.itemService.showSpinner = false;
    } else {
      // console.log('Date Change Block')
      this.itemService.dateChangeDetector();
    }
  }

}


// WEBPACK FOOTER //
// ./src/app/advertisers/advertisers.component.ts